<div class="bg-color-orange color-white u-padding-16">
  <div
    fxLayout="row"
    fxLayoutGap="8px"
    class="u-margin-center"
    [ngStyle]="{ 'max-width': '1000px', width: '95vw' }"
  >
    <mat-icon>error_outline</mat-icon>
    <div>
      <ng-container i18n="@@profileView.emailVerification.text"
        >We're almost there! We just need you to confirm your email address.
        Check your {{ user.email }} account or </ng-container
      >&nbsp;
      <a
        i18n="@@profileView.requestConfirmationLink.label"
        class="u-textDecoration-underline"
        (click)="resendVerificationEmail()"
        >request a new confirmation link</a
      >.
    </div>
  </div>
</div>
